import { Center, Text } from '@chakra-ui/react';

export const LoadingMoreIndicator = () => {
  return (
    <Center pt={2}>
      <Text color="textSubdued" fontSize="sm">
        Loading history...
      </Text>
    </Center>
  );
};
